<template>
    <div>
        <publish-page view-type="author"></publish-page>
    </div>
</template>

<script>
import PublishPage from "@/components/PublishPage"

export default {
    name: "PublishPageEditor",
    components: {
        PublishPage,
    },
}
</script>

<style></style>